var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelamentoApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 162,
    height: 162,
    viewBox: "0 0 162 162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 81,
    r: 81,
    fill: "#DFFAFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(53 31)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21C5E5",
    d: "M6.33 16.426h49v68h-49z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#009BBF",
    strokeWidth: 3,
    d: "M9.33 1.926a7.5 7.5 0 0 0-7.5 7.5v81a7.5 7.5 0 0 0 7.5 7.5h34a7.5 7.5 0 0 0 7.5-7.5v-81a7.5 7.5 0 0 0-7.5-7.5h-34z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#009BBF",
    strokeWidth: 3,
    d: "M1.83 11.926v76h49v-76h-49z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 2,
    x: 17.33,
    y: 6.426,
    fill: "#009BBF",
    rx: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelamentoApp);
export default __webpack_public_path__ + "static/media/cancelamento-app.2580721cf2e1acb39fdd547f3f5c35e5.svg";
export { ForwardRef as ReactComponent };